import * as React from 'react';
import { IntlProvider } from 'react-intl';
import type { ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { BoundScrollProvider, ModalProvider, NoticeBannersStackProvider } from '@sg/garnish';

import { StripePaymentProvider } from '@order/integrations/stripe';
import { TelemetryProvider } from '@order/Telemetry';

import { BrazeProvider } from './context/Braze';
import { CustomerProvider } from './context/Customer';
import { GlobalAppState } from './context/GlobalAppState';

export const Providers = (props: Pick<ViewProps, 'children'>) => (
  <SafeAreaProvider>
    <GestureHandlerRootView style={StyleSheet.absoluteFill}>
      <IntlProvider locale="en-US" defaultLocale="en-US">
        <StripePaymentProvider>
          <NoticeBannersStackProvider>
            <TelemetryProvider>
              <GlobalAppState>
                <ModalProvider>
                  <CustomerProvider>
                    <BrazeProvider>
                      <BoundScrollProvider>{props.children}</BoundScrollProvider>
                    </BrazeProvider>
                  </CustomerProvider>
                </ModalProvider>
              </GlobalAppState>
            </TelemetryProvider>
          </NoticeBannersStackProvider>
        </StripePaymentProvider>
      </IntlProvider>
    </GestureHandlerRootView>
  </SafeAreaProvider>
);
